import React from 'react'
import './general-title.css'

const GenealTitle = ({ title }) => (
  <>
    <div className='header' />
    <div className='title'>
      <h3 className='title-text'>{title}</h3>
    </div>
  </>
)

export default React.memo(GenealTitle)
